// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"130":"2bf9e743","138":"73bc7414","485":"1dd6cbf2","553":"ff11a717","609":"9ebe6541","656":"1e78a9ed","734":"151a9f3e","855":"ee30053f","909":"6e7f58e4"}[chunkId] + ".js";
};